export interface CompanyProfile {
  version: string;
  verifiedAt: string;
  company: {
    name: string;
    types: string[];
    headquarters: { province: string; city: string };
    employeeCount: number;
    businessYears: number;
    annualRevenueKrw: number;
  };
  capabilities: string[];
  targetMarkets: string[];
  regionsOfInterest: string[];
  partnerships: string[];
  constraints: { autoExternalActions: false };
}

export const DEFAULT_COMPANY_PROFILE: CompanyProfile = {
  version: "2026-07-21-v1",
  verifiedAt: "2026-07-21",
  company: {
    name: "주식회사 에이아이큐브",
    types: ["중소기업", "벤처기업", "소공인"],
    headquarters: { province: "경기도", city: "화성시" },
    employeeCount: 4,
    businessYears: 5,
    annualRevenueKrw: 1_200_000_000,
  },
  capabilities: ["AIoT", "디지털 사이니지", "온디바이스 AI", "음성인식", "엣지 컴퓨팅", "MQTT", "공공 대시보드", "접근성 키오스크", "영상 안전 감지"],
  targetMarkets: ["지자체", "공공기관", "병원", "소공인", "스마트팩토리"],
  regionsOfInterest: ["경기도", "화성시", "오산시", "충청북도", "제천시"],
  partnerships: [],
  constraints: { autoExternalActions: false },
};
